angular.module('skeyenoteWebApp').service('searchService', SearchService);

function SearchService($resource, baseUrlSrv) {
  'ngInject';

  this.search = function(term) {
    this.searchTerm = term.q;
    console.log('Searching for: %o', term.q);
    if (!term.q) { // TODO(bzz): empty string check
      return;
    }
    let encQuery = window.encodeURIComponent(term.q);
    return $resource(baseUrlSrv.getRestApiBase() + '/notebook/search?q=' + encQuery, {}, {
      query: {method: 'GET'},
    });
  };

  this.searchTerm = '';
}
